import { NSABoxSecret, NSARouterMakerResult } from 'namirasoft-account-react';
import { NSBox, NSBoxString, NSColumn, NSRow } from 'namirasoft-site-react';
import { StorageUserInputRow, StorageUserRow } from 'namirasoft-storage';
import { Component, createRef } from 'react';
import AssignmentsTable from '../components/AssignmentsTable';
import { StorageEntities } from '../StorageEntities';
import { StorageLayout } from '../StorageLayout';
import { StorageRouterProps } from '../StorageRouterProps';

export interface StorageUserEditPageProps extends NSARouterMakerResult, StorageRouterProps
{
    isEdit: boolean;
}

export default class StorageUserEditPage extends Component<StorageUserEditPageProps>
{
    private StorageUserNameBox_Name = createRef<NSBoxString>();
    private NSABoxSecret_Password = createRef<NSABoxSecret>();

    private getCurrentUserId(): string
    {
        return this.props.account.token_manager.getUserData(u => u.id, "") ?? "";
    }

    override render()
    {
        const currentUserId = this.getCurrentUserId();
        const defaultPrefix = currentUserId ? `${currentUserId}-` : "";

        return (
            <StorageLayout<StorageUserRow, StorageUserInputRow>
                {...this.props}
                pages={{
                    entity: StorageEntities.storage_user(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): StorageUserInputRow =>
                                    {
                                        return {
                                            name: this.StorageUserNameBox_Name.current?.getValue() ?? "",
                                            password: this.NSABoxSecret_Password.current?.getValue() ?? "",
                                        };
                                    },
                                    setRow: (row: StorageUserRow) =>
                                    {
                                        const prefix = row.user_id ? `${row.user_id}-` : "";
                                        this.StorageUserNameBox_Name.current?.setPrefix(prefix, () =>
                                        {
                                            this.StorageUserNameBox_Name.current?.setValue(row.name);
                                        });
                                        this.NSABoxSecret_Password.current?.setValue(row.password_secret_id);
                                    }
                                }
                            },
                            tab_page_view: {
                                tabs: {
                                    extra: {
                                        after_general: [
                                            {
                                                title: "Assignment",
                                                clicked: false,
                                                isVisible: (model) => !!model.id,
                                                getContent: (model) =>
                                                {
                                                    if (!model.id)
                                                        return null;
                                                    return (
                                                        <AssignmentsTable
                                                            {...this.props}
                                                            storage_user_id={model.id}
                                                        />
                                                    );
                                                },
                                            },
                                        ],
                                    },
                                },
                            },
                        }
                    }
                }}
            >
                <NSColumn style={{ maxWidth: "35rem" }}>
                    <NSRow style={{ justifyContent: "flex-start" }}>
                        <NSBoxString
                            ref={this.StorageUserNameBox_Name}
                            title="Name"
                            required
                            prefix={defaultPrefix}
                            style={{ width: NSBox.width.double }}
                        />
                        <NSABoxSecret
                            ref={this.NSABoxSecret_Password}
                            {...this.props}
                            title="Password"
                            required
                            auto_complete='one-time-code'
                            style={{ width: NSBox.width.double }}
                        />
                    </NSRow>
                </NSColumn>
            </StorageLayout>
        );
    }
}